module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-col page"
  }, [_c('div', {
    staticClass: "flex-col group_3"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('CarCard', {
    attrs: {
      "carDetails": _vm.carDetail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section_3"
  }, [_c('div', {
    staticClass: "justify-between group_9"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('span', {
    staticClass: "text_12"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "text_13",
    attrs: {
      "type": "text",
      "placeholder": "请输入您的姓名"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text_14"
  }, [_vm._v("先生/女士")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row group_11"
  }, [_c('span', {
    staticClass: "text_15"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPhone),
      expression: "userPhone"
    }],
    staticClass: "text_16",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.userPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-col section_4"
  }, [_c('van-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('van-collapse-item', {
    attrs: {
      "title": "参数配置",
      "name": "1"
    }
  }, [_c('van-cell-group', _vm._l((_vm.paramConfig), function(item) {
    return _c('van-cell', {
      key: item.label,
      attrs: {
        "title": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('van-collapse-item', {
    attrs: {
      "title": "车身尺寸",
      "name": "2"
    }
  }, [_c('van-cell-group', _vm._l((_vm.carSize), function(item) {
    return _c('van-cell', {
      key: item.label,
      attrs: {
        "title": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.carDetail.cartypeDetailImg) ? _c('div', {
    staticClass: "flex-col items-center text-wrapper_2"
  }, [_vm._l((_vm.carDetail.cartypeDetailImg.split(',')), function(src) {
    return [_c('img', {
      attrs: {
        "src": _vm.mixin_imgs[_vm.getOSSImg(src)],
        "alt": ""
      }
    })]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-col footer"
  }, [_c('div', {
    staticClass: "flex-row group_16"
  }, [_c('img', {
    staticClass: "image_5",
    attrs: {
      "src": _vm.isAgree ? 'https://imgpub1.shouqiev.com/gofunplatform/files/20220801/cByvEyzDVF.png' : 'https://imgpub1.shouqiev.com/gofunplatform/files/20220816/wwPATTpQyZ.png'
    },
    on: {
      "click": function($event) {
        _vm.isAgree = !_vm.isAgree
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "group_17"
  }, [_c('span', {
    staticClass: "text_28",
    on: {
      "click": function($event) {
        _vm.isAgree = !_vm.isAgree
      }
    }
  }, [_vm._v("阅读并同意")]), _vm._v(" "), _vm._l((_vm.agreements), function(item) {
    return [_c('span', {
      staticClass: "text_29",
      on: {
        "click": function($event) {
          return _vm.jsBridge.appOpenUrl(("https://h5.shouqiev.com/app/pdf/web/viewer.html?file=" + (item.templateUrl) + "&title=" + (item.templateName)))
        }
      }
    }, [_vm._v(_vm._s(item.templateName))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex-col items-center button",
    on: {
      "click": _vm.makeOrder
    }
  }, [_c('span', {
    staticClass: "text_30"
  }, [_vm._v("去预定")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a94e6876", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-a94e6876","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/saleCar/car/carDetail.vue
// module id = 284
// module chunks = 320 321